import {
  ChallengeField,
  ChallengeFieldError,
  ChallengeSection,
  ChallengeSectionLabel,
} from '@/components/challenge/components';
import {
  MAX_DESCRIPTION_LENGTH,
  MAX_TITLE_LENGTH,
} from '@/components/challenge/CompanyChallengeManagement/constants';
import { IChallengeFormValues } from '@/components/challenge/CompanyChallengeManagement/types';
import { useFormikContext } from 'formik';
import { FC } from 'react';

const DESCRIPTION_MIN_ROWS = 2;
const DESCRIPTION_MAX_ROWS = 5;

export const ChallengeBasicInfoFields: FC = () => {
  const { values, errors, touched, handleChange, handleBlur } =
    useFormikContext<IChallengeFormValues>();

  const showTitleError = Boolean(touched.title && errors.title);
  const showDescriptionError = Boolean(
    touched.description && errors.description
  );

  return (
    <>
      <ChallengeSection>
        <ChallengeSectionLabel variant="h3">
          Header / Title
        </ChallengeSectionLabel>
        <ChallengeField
          fullWidth
          name="title"
          placeholder="Enter challenge header / title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          inputProps={{ maxLength: MAX_TITLE_LENGTH }}
          error={showTitleError}
        />
        {showTitleError && (
          <ChallengeFieldError>{errors.title}</ChallengeFieldError>
        )}
      </ChallengeSection>

      <ChallengeSection>
        <ChallengeSectionLabel variant="h3">Description</ChallengeSectionLabel>
        <ChallengeField
          fullWidth
          multiline
          minRows={DESCRIPTION_MIN_ROWS}
          maxRows={DESCRIPTION_MAX_ROWS}
          name="description"
          placeholder="Enter challenge description"
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
          error={showDescriptionError}
        />
        {showDescriptionError && (
          <ChallengeFieldError>{errors.description}</ChallengeFieldError>
        )}
      </ChallengeSection>
    </>
  );
};
